import styles from './DashboardReportingAuditingSplash.module.scss';

import React from 'react';
import Link from 'gatsby-link';
import RetinaImage from 'src/components/RetinaImage';
import { Button, Container, Row, Col } from 'reactstrap';
import { ScrollOverPack, TweenOne, FadeLeft } from 'src/components/Animations';

import ImgLaptopZoneAndWeight from 'src/images/img-laptop-zone-and-weight.png';
import ImgLaptopZoneAndWeight2x from 'src/images/img-laptop-zone-and-weight@2x.png';

export default (props) => (
  <div styleName='dashboard-reporting-auditing-splash'>
      <Container>
          <div styleName='text-container'>
              <div className='h2'>Useful alone</div>
              <div className='h2 text-blue'>Better together.</div>
              <div styleName='message'>
                  Our tools play nicely together. Get answers faster when
                  everything you need is in one place.
              </div>
              <div styleName='features-table'>
                  <div styleName='feature-row'>
                      <div styleName='heading'>Dashboard</div>
                      <div>
                          Get the 10,000 foot view. Seeing your data visualized
                          lets you zero in quickly on areas that need attention.
                      </div>
                  </div>
                  <div styleName='feature-row'>
                      <div styleName='heading'>Reporting</div>
                      <div>
                          Dive deep. Pull normalized cross-carrier data in
                          analysis-ready formats that your local Excel jockey will
                          love.
                      </div>
                  </div>
                  <div styleName='feature-row'>
                      <div styleName='heading'>Auditing</div>
                      <div>
                          Put the rest on autopilot. When you’re not looking for
                          trouble in your shipping data, Galleon’s AI-powered
                          audit does it for you.
                      </div>
                  </div>
              </div>
          </div>
      </Container>
      <ScrollOverPack styleName='splash-image-container'>
          <TweenOne key='0'
                    component={RetinaImage}
                    srcSet={[ImgLaptopZoneAndWeight, ImgLaptopZoneAndWeight2x]}
                    styleName='splash-image'
                    {...FadeLeft} />
      </ScrollOverPack>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/DashboardReportingAuditingSplash.js